<template>
    <v-container fluid>
        <template v-if="category">
            <category-form
                :category="category"
                :resellerTypes="resellerTypes"
                :titlePrefix="$t('forms.title_prefix.edit')"
                @saved="saved"
            />

            <v-row class="mt-5 mb-8">
                <v-col cols="12" md="6">
                    <span class="overline ml-2">{{
                        $tc('resources.activation.name', 2)
                    }}</span>
                    <v-row class="mt-2">
                        <activation-index :categoryId="category.id" />
                    </v-row>
                </v-col>

                <v-col cols="12" md="6">
                    <span class="overline ml-2">{{
                        $tc('resources.rule.name', 2)
                    }}</span>
                    <v-row class="mt-2">
                        <rule-index :categoryId="category.id" />
                    </v-row>
                </v-col>
            </v-row>

            <template v-if="hasBusinessConsultant">
                <v-divider class="my-4"></v-divider>
                <v-row>
                    <v-col cols="12" md="6">
                        <span class="overline ml-2">{{
                            $tc('resources.cycle_rule.name', 2)
                        }}</span>
                        <v-row class="mt-2">
                            <cycle-rule-index :categoryId="category.id" />
                        </v-row>
                    </v-col>
                </v-row>
            </template>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import CategoryForm from './Form'
import Category from '@/models/Category'
import ActivationIndex from './activations/Index'
import RuleIndex from './rules/Index'
import CycleRuleIndex from './cycle-rules/Index'
import ResellerType from '@/models/ResellerType'

export default {
    props: {
        id: {
            required: true,
        },
    },

    components: {
        CategoryForm,
        ActivationIndex,
        RuleIndex,
        CycleRuleIndex,
    },

    data: () => {
        return {
            category: null,
            activeTab: 0,
            resellerTypes: [],
        }
    },

    computed: {
        hasBusinessConsultant() {
            if (
                !this.category ||
                !this.category.reseller_type_ids ||
                !this.resellerTypes
            ) {
                return false
            }

            return this.category.reseller_type_ids.some(
                type =>
                    type ===
                    this.resellerTypes.find(
                        resellerType =>
                            resellerType.referable ===
                            ResellerType.businessConsultant,
                    ).id,
            )
        },
    },

    methods: {
        async getCategory() {
            let category = await new Category().find(this.id)
            category.reseller_type_ids = category.resellerTypes.map(
                row => row.id,
            )
            this.category = category
        },

        async loadResellerTypes() {
            let res = await new ResellerType().all()
            this.resellerTypes = res.data
        },

        saved() {
            this.$router.push({ name: 'category.index' })
        },
    },

    created() {
        this.getCategory()
        this.loadResellerTypes()
    },
}
</script>

<style></style>
